<span style="color:red;" *ngIf="message">{{message}}</span>
<input #file type="file" accept='image/*' (change)="loadImage(file.files)" />
<!-- <img [src]="imgURL" height="200" *ngIf="imgURL"> -->
